import React, { Component } from 'react';
import { css } from 'aphrodite';

import { ReportBox, Flexbox, Font, Text } from './Styles'
import Image from './Image';
import PrimaryButton from './PrimaryButton';

import Locale from './models/Locale';

class GameOver extends Component {
  render() {
    let failingText = undefined;
    let numberOfFailures = ((this.props.score.c < 0)? 1 : 0) + 
                           ((this.props.score.p < 0)? 1 : 0) + 
                           ((this.props.score.q < 0)? 1 : 0);
    if (numberOfFailures > 1) {
      failingText = Locale.localized("Oh No! Some of your scores fell below 0, and you have lost the game.");
    } else if (this.props.score.c < 0) {
      failingText = Locale.localized("Oh No! Your Money fell below 0, and you have lost the game.");
    } else if (this.props.score.p < 0) {
      failingText = Locale.localized("Oh No! Your Preparedness fell below 0, and you have lost the game.");
    } else if (this.props.score.q < 0) {
      failingText = Locale.localized("Oh No! Your Quality of Life fell below 0, and you have lost the game,");
    }

    return(
      <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter, ReportBox.container)}>
          <Image extraStyles={ReportBox.topImage} filename="gameover.png" />
          <div className={css(Font.largeHeading, Text.heading)}>{Locale.localized("Status Report")}</div>
          <div className={css(Font.heading, Text.heading)}>{Locale.localized("Game Over")}</div>
          <div className={css(Flexbox.centeredItem, Text.textBlock)}>{failingText}</div>
          <div className={css(Flexbox.grow, Flexbox.centeredItem, Text.textBlock)}>{this.props.event.gameover_message}</div>
          <div onClick={this.props.onComplete.bind(this)}>
            <PrimaryButton>{Locale.localized("Play Again")}</PrimaryButton>
          </div>
        </div>
      </div>
    );
  }
}

export default GameOver;



// WEBPACK FOOTER //
// ./src/GameOver.js